import React from "react";
import { Text, Toggle, Tooltip } from "@merge-api/merge-javascript-shared";
import ConfigurationSettingsCard from "../helpers/ConfigurationSettingsCard";
import useCustomizationContext from "../context/useCustomizationContext";
import { MergeLinkCustomizationStatus } from "../context/CustomizationContext";

const ConfigurationBrandingToggleCard = () => {
  const { organizationCustomization, setOrganizationCustomization, logo } =
    useCustomizationContext();
  const showCobranding = organizationCustomization?.show_cobranding ?? false;

  const updateShowCobranding = (newValue: boolean) => {
    // either create new org customization value or update existing one
    if (organizationCustomization != undefined) {
      const newOrgCustomization = { ...organizationCustomization };
      newOrgCustomization.show_cobranding = newValue;
      setOrganizationCustomization(newOrgCustomization);
    } else {
      const currentOrganizationCustomization = {
        status: "PUBLISHED" as MergeLinkCustomizationStatus,
        show_cobranding: newValue,
      };
      setOrganizationCustomization(currentOrganizationCustomization);
    }
  };

  return (
    <ConfigurationSettingsCard title="Enable co-branding in Merge Link">
      <div className="flex flex-row justify-between items-center">
        <Text>Show your own logo alongside the third-party integration logo</Text>
        {logo == null ? (
          <Tooltip title={<Text>You must upload a logo before enabling co-branding</Text>}>
            <Toggle
              label={showCobranding ? "Enabled" : "Disabled"}
              checked={showCobranding}
              onChange={() => updateShowCobranding(!showCobranding)}
              disabled={logo == null}
            />
          </Tooltip>
        ) : (
          <Toggle
            label={showCobranding ? "Enabled" : "Disabled"}
            checked={showCobranding}
            onChange={() => updateShowCobranding(!showCobranding)}
            disabled={logo == null}
          />
        )}
      </div>
    </ConfigurationSettingsCard>
  );
};

export default ConfigurationBrandingToggleCard;
